module.exports = __webpack_public_path__ + "img/resultado-indicadores.0e69e39f.svg";